module.exports = __webpack_public_path__ + "assets/img/home2-bg.be2c4613.png";